import { fromJS } from 'immutable';

import {
  LOAD_DISCUSSIONS,
  LOAD_DISCUSSIONS_SUCCESS,
  LOAD_DISCUSSIONS_ERROR,
  SET_UNREAD_MESSAGE_COUNT,
  SET_RELOAD_DISCUSSIONS,
  CLEAR_DISCUSSIONS,
  INCREMENT_UNREAD_MESSAGE_COUNT,
  RELOAD_DISCUSSIONS,
  RELOAD_DISCUSSIONS_SUCCESS,
} from './constants';

const initialState = fromJS({
  campaignId: null,
  error: null,
  loading: false,
  discussions: {},
  reloadDiscussions: false,
});

function discussionListReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_DISCUSSIONS:
    return state
      .set('discussions', fromJS({}))
      .set('error', null)
      .set('loading', true)
      .set('campaignId', action.campaignId);
  case CLEAR_DISCUSSIONS:
    return initialState;
  case LOAD_DISCUSSIONS_SUCCESS:
    return state
      .set('discussions', action.discussions)
      .set('error', null)
      .set('loading', false);
  case LOAD_DISCUSSIONS_ERROR:
    return state
      .set('error', action.error)
      .set('loading', false);
  case RELOAD_DISCUSSIONS:
    return state
      .set('reloadDiscussions', true);
  case RELOAD_DISCUSSIONS_SUCCESS:
    return state
      .set('reloadDiscussions', false);
  case SET_UNREAD_MESSAGE_COUNT:
    return state.setIn(['discussions', action.discussionId, 'unreadMessageCount'], action.unreadMessageCount);
  case INCREMENT_UNREAD_MESSAGE_COUNT: {
    let unreadMessageCount = state.getIn(['discussions', action.discussionId, 'unreadMessageCount']);
    return state.setIn(['discussions', action.discussionId, 'unreadMessageCount'], unreadMessageCount++);
  }
  default:
    return state;
  }
}

export default discussionListReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/discussion-list/reducer.js
 **/